// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_1y2","cls2":"AvatarCell-cls2_Xd- AvatarCell-cls1_1y2"};